var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    { ref: "form-register" },
    [
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("E-mail Address"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            attrs: { required: "" },
            model: {
              value: _vm.user.email_address,
              callback: function ($$v) {
                _vm.$set(_vm.user, "email_address", $$v)
              },
              expression: "user.email_address",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Password"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            attrs: { type: "password", required: "" },
            model: {
              value: _vm.user.password,
              callback: function ($$v) {
                _vm.$set(_vm.user, "password", $$v)
              },
              expression: "user.password",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Confirm password"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            attrs: { type: "password", required: "" },
            model: {
              value: _vm.user.password_confirm,
              callback: function ($$v) {
                _vm.$set(_vm.user, "password_confirm", $$v)
              },
              expression: "user.password_confirm",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Customer number"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            model: {
              value: _vm.user.customer_number,
              callback: function ($$v) {
                _vm.$set(_vm.user, "customer_number", $$v)
              },
              expression: "user.customer_number",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Company"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            attrs: { required: "" },
            model: {
              value: _vm.user.company,
              callback: function ($$v) {
                _vm.$set(_vm.user, "company", $$v)
              },
              expression: "user.company",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("First Name"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            attrs: { required: "" },
            model: {
              value: _vm.user.first_name,
              callback: function ($$v) {
                _vm.$set(_vm.user, "first_name", $$v)
              },
              expression: "user.first_name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Last Name"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            attrs: { required: "" },
            model: {
              value: _vm.user.last_name,
              callback: function ($$v) {
                _vm.$set(_vm.user, "last_name", $$v)
              },
              expression: "user.last_name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Address"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            model: {
              value: _vm.user.address,
              callback: function ($$v) {
                _vm.$set(_vm.user, "address", $$v)
              },
              expression: "user.address",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Zip Code"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            model: {
              value: _vm.user.zip_code,
              callback: function ($$v) {
                _vm.$set(_vm.user, "zip_code", $$v)
              },
              expression: "user.zip_code",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("City"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            model: {
              value: _vm.user.city,
              callback: function ($$v) {
                _vm.$set(_vm.user, "city", $$v)
              },
              expression: "user.city",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Country"), "label-cols": "3" } },
        [
          _c("b-form-select", {
            attrs: {
              options: _vm.CountryList,
              "text-field": "name",
              "value-field": "code",
              required: "",
            },
            model: {
              value: _vm.user.country_code,
              callback: function ($$v) {
                _vm.$set(_vm.user, "country_code", $$v)
              },
              expression: "user.country_code",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Phone number"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            model: {
              value: _vm.user.phone_number,
              callback: function ($$v) {
                _vm.$set(_vm.user, "phone_number", $$v)
              },
              expression: "user.phone_number",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Mobile number"), "label-cols": "3" } },
        [
          _c("b-form-input", {
            model: {
              value: _vm.user.mobile_number,
              callback: function ($$v) {
                _vm.$set(_vm.user, "mobile_number", $$v)
              },
              expression: "user.mobile_number",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: _vm.$t("Captcha"), "label-cols": "3" } },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "Type in the result of the following calculation. This will help to protect us from spam bots."
                    )
                  )
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-auto" }, [
              _c("img", {
                attrs: {
                  alt: "Captcha",
                  src: _vm.UserService.registerCaptchaUri(),
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("b-form-input", {
                  attrs: { state: _vm.captcha_state, required: "" },
                  model: {
                    value: _vm.user.captcha_result,
                    callback: function ($$v) {
                      _vm.$set(_vm.user, "captcha_result", $$v)
                    },
                    expression: "user.captcha_result",
                  },
                }),
                _vm._v(" "),
                _c("b-form-invalid-feedback", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("This value is invalid.")) +
                      "\n                "
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }